import { Component, HostListener, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeExtService } from '../employee-ext.service';
import { EmployeeExtModel } from '../model/employee-ext.model';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { DepartmentModel } from '../../../system/shopinfo/model/shopinfo.model';
import { EmployeeCategoryModel } from '../../employee-category/employee-category/model/employee-category.model';
import { PermissionService } from 'src/app/auth/permission.service';
import { StaffPayrollGroupService } from '../../../payroll/staff-payroll-group/staff-payroll-group.service';

@Component({
  selector: 'app-employee-ext-edit',
  standalone: false,
  templateUrl: './employee-ext-edit.component.html',
  styleUrl: './employee-ext-edit.component.scss'
})
export class EmployeeExtEditComponent {
  title: string = "New Employee ";
  editForm: FormGroup;
  employeeInfo: EmployeeExtModel = {};
  isFormDirty: boolean = false;
  sameAsAbove: boolean = false;
  departmentList: DepartmentModel[] = [];
  categoryList: EmployeeCategoryModel[] = [];
  permission: any;

  shopEmployeeMapping: any[] = [];
  sortedShopEmployeeMapping: any[] = [];
  shopEmployeeMappingLoadedFromSetEmployeeInfo = false;
  areaList: string[] = [];
  selectedAreas: string[] = [];
  shopSearch: string = '';
  selectedTabIndex: number = 0;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private employeeService: EmployeeExtService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private staffPayrollService: StaffPayrollGroupService) {

    let employeeId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.employeeInfo.code, [Validators.required, Validators.maxLength(10)]),
      f_name: this.builder.control(this.employeeInfo.f_name, [Validators.required, Validators.maxLength(50)]),
      m_name: this.builder.control(this.employeeInfo.m_name),
      l_name: this.builder.control(this.employeeInfo.l_name),
      gender: this.builder.control(this.employeeInfo.gender),
      employee_status: this.builder.control(this.employeeInfo.employee_status),
      cost_per_hour: this.builder.control(this.employeeInfo.cost_per_hour, [Validators.required, this.nonNegativeValidator()]),
      over_time_pay_rate: this.builder.control(this.employeeInfo.over_time_pay_rate),
      work_permit: this.builder.control(this.employeeInfo.work_permit),
      card_no: this.builder.control(this.employeeInfo.card_no, [Validators.required]),
      address: this.builder.control(this.employeeInfo.address),
      country: this.builder.control(this.employeeInfo.country),
      zip_code: this.builder.control(this.employeeInfo.zip_code),
      phone: this.builder.control(this.employeeInfo.phone, [
        Validators.pattern(/^[0-9]{7,15}$/) // allows 7-15 digits, adjust as needed
      ]),
      fax: this.builder.control(this.employeeInfo.fax),
      email: this.builder.control(this.employeeInfo.email, [Validators.email]),
      loc_address: this.builder.control(this.employeeInfo.loc_address),
      loc_country: this.builder.control(this.employeeInfo.loc_country),
      loc_zip_code: this.builder.control(this.employeeInfo.loc_zip_code),
      loc_phone: this.builder.control(this.employeeInfo.loc_phone, [
        Validators.pattern(/^[0-9]{7,15}$/) // allows 7-15 digits, adjust as needed
      ]),
      payroll_code: this.builder.control(this.employeeInfo.payroll_code, [
        Validators.required,
        Validators.maxLength(7),
        Validators.minLength(7)
      ]),
      can_export: this.builder.control(this.employeeInfo.can_export == 1),

      loc_fax: this.builder.control(this.employeeInfo.loc_fax),
      employee_category_id: this.builder.control(this.employeeInfo.employee_category_id),
      department_id: this.builder.control(this.employeeInfo.department_id),
      preferred_name: this.builder.control(this.employeeInfo.preferred_name),
      full_name: this.builder.control(this.employeeInfo.full_name),
      display_name: this.builder.control(this.employeeInfo.display_name),
      job_position: this.builder.control(this.employeeInfo.job_position),
      job_title: this.builder.control(this.employeeInfo.job_title),
      sort_order: this.builder.control(this.employeeInfo.sort_order),
      min_work_hours: this.builder.control(this.employeeInfo.min_work_hours, [this.nonNegativeValidator()]),
      max_work_hours: this.builder.control(this.employeeInfo.max_work_hours, [this.nonNegativeValidator()]),
      work_email: this.builder.control(this.employeeInfo.work_email, [Validators.email]),
      work_phone: this.builder.control(this.employeeInfo.work_phone),
      phone_daytime: this.builder.control(this.employeeInfo.phone_daytime),
      is_partner: this.builder.control(this.employeeInfo.is_partner === true || this.employeeInfo.is_partner === 1 as any),
      is_salary_staff: this.builder.control(this.employeeInfo.is_salary_staff === true || this.employeeInfo.is_salary_staff === 1 as any)
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (employeeId !== null && parseInt(employeeId) !== 0) {
      this.setemployeeInfo(employeeId);
    } else {
      this.editForm.get('payroll_code')?.clearValidators();
      this.editForm.get('payroll_code')?.updateValueAndValidity();
    }

    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission('employee'), employeeId);
    this.permission.can_add = false;
    this.permission.can_delete = false;
    this.permission.can_edit = false;

  }
  ngOnInit(): void {
    //  this.loadRating();    
    this.loadData();
    this.CategoryLoadData();

    let employeeId = this.route.snapshot.paramMap.get('id');
    if (!employeeId || parseInt(employeeId) === 0) {
      this.employeeService.getShopEmployeeMapping(0).subscribe({
        next: (res) => {
          this.zone.run(() => {
            if (res.status === 'SUCCESS') {
              this.shopEmployeeMapping = [...res.data];
              this.areaList = Array.from(new Set(this.shopEmployeeMapping.map((shop: any) => shop.city))).filter(Boolean) as string[];
              this.selectedAreas = [...this.areaList];
              this.sortedShopEmployeeMapping = this.getFilteredAndSortedShopEmployeeMapping();
            } else {
              this.shopEmployeeMapping = [];
              this.areaList = [];
              this.selectedAreas = [];
              this.sortedShopEmployeeMapping = [];
            }
            this.cdr.detectChanges();
          });
        },
        error: (err) => {
          console.error("Failed to load shop employee mapping for new user", err);
        }
      });
    }
  }

  isDirty(): boolean {
    return this.isFormDirty;

  }

  navBack(): void {

    this.router.navigate(['/employee/employee-ext']);

  }

  setemployeeInfo(employeeId: any): void {

    let response = this.employeeService.getEmployeeById(employeeId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          const emp = response.data.employee;
          this.employeeInfo = {
            id: emp.employee_id || emp.id,
            code: emp.employee_id || emp.code,
            f_name: emp.first_name || emp.f_name,
            m_name: emp.middle_name || emp.m_name,
            l_name: emp.last_name || emp.l_name,
            gender: emp.gender,
            employee_status: emp.employee_status,
            cost_per_hour: emp.cost_per_hour,
            email: emp.email || emp.work_email,
            loc_phone: emp.work_phone || emp.loc_phone,
            phone: emp.phone_mobile || emp.phone,
            payroll_code: emp.payroll_code,
            can_export: emp.can_export == '1' || emp.can_export === true,
            doj: emp.doj,
            dob: emp.dob,
            address: emp.address,
            country: emp.country,
            zip_code: emp.zip_code,
            fax: emp.fax,
            loc_address: emp.loc_address,
            loc_country: emp.loc_country,
            loc_zip_code: emp.loc_zip_code,
            loc_fax: emp.loc_fax,
            card_no: emp.card_no,
            employee_category_id: emp.employee_category_id ? Number(emp.employee_category_id) : undefined,
            department_id: emp.department_id ? Number(emp.department_id) : undefined,
            over_time_pay_rate: emp.over_time_pay_rate,
            work_permit: emp.work_permit,
            preferred_name: emp.preferred_name,
            full_name: emp.full_name,
            display_name: emp.display_name,
            job_position: emp.job_position,
            job_title: emp.job_title,
            sort_order: emp.sort_order,
            is_salary_staff: emp.is_salary_staff == '1' || emp.is_salary_staff === true,
            is_partner: emp.is_partner == '1' || emp.is_partner === true,
            min_work_hours: emp.min_work_hours,
            max_work_hours: emp.max_work_hours,
            work_email: emp.work_email,
            work_phone: emp.work_phone,
            phone_daytime: emp.phone_daytime
          };

          this.shopEmployeeMappingLoadedFromSetEmployeeInfo = true;
          this.editForm.patchValue(this.employeeInfo);

          // Populate shops directly from the response
          this.zone.run(() => {
            this.shopEmployeeMapping = (emp.shops || []).map((s: any) => ({
              id: s.shop_code || s.id,
              code: s.shop_code || s.code,
              name: s.name,
              city: s.city,
              is_exists: s.is_active == '1' || s.is_active === true ? '1' : '0',
              is_primary: s.is_primary == '1' || s.is_primary === true,
              start_date: s.start_date,
              end_date: s.end_date,
              notes: s.notes
            }));

            // To support Area filtering correctly without an additional API request,
            // ideally the API returns City. But since it doesn't, we fallback to extracting from mapped.
            this.areaList = Array.from(new Set(this.shopEmployeeMapping.map((shop: any) => shop.city))).filter(Boolean) as string[];
            this.selectedAreas = [...this.areaList];
            this.sortedShopEmployeeMapping = this.getFilteredAndSortedShopEmployeeMapping();
            // console.log("Newly mapped shop data:", this.sortedShopEmployeeMapping);
            this.cdr.detectChanges();
          });

          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }


  getTitle(): string {
    let title = (this.employeeInfo.id == 0) ? "New Employee" : "Editing : " + this.employeeInfo.f_name;
    return title;
  }

  updatePayroll(): void {
    if (this.editForm.get('payroll_code')?.valid) {
      const payrollData: any = {
        id: this.employeeInfo.id,
        payroll_code: this.editForm.get('payroll_code')?.value,
        can_export: this.editForm.get('can_export')?.value ? 1 : 0,
        shop_id: 0 // Default for HQ/General update
      };

      this.staffPayrollService.update(payrollData).subscribe({
        next: (response: any) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'payroll details in employee updated sucessfully'
            }
            this.snackBarService.openSnackBar(snckBarData);
          } else {
            this.snackBarService.openSnackBar({
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            });
          }
        },
        error: (error: any) => {
          this.snackBarService.openSnackBar({
            message: 'Failed to update payroll. Connection error.',
            title: 'Failed!!!',
            type: 'error'
          });
        }
      });
    } else {
      this.editForm.get('payroll_code')?.markAsTouched();
    }
  }

  save(): void {
    this.updatePayroll();
  }

  onSameAsAboveChange(checked: boolean) {
    this.sameAsAbove = checked;
    if (checked) {
      this.editForm.patchValue({
        loc_address: this.editForm.get('address')?.value,
        loc_country: this.editForm.get('country')?.value,
        loc_zip_code: this.editForm.get('zip_code')?.value,
        loc_phone: this.editForm.get('phone')?.value,
        loc_fax: this.editForm.get('fax')?.value,
      });
    } else {
      this.editForm.patchValue({
        loc_address: '',
        loc_country: '',
        loc_zip_code: '',
        loc_phone: '',
        loc_fax: '',
      });
    }
  }

  loadData(): void {
    let requestData = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [{ "column": "name", "order": "asc" }] } }
    let response = this.employeeService.getDepartmentList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {

        this.departmentList = response.data.departments;

      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }

    });

  }


  CategoryLoadData(): void {
    let requestData = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [{ "column": "name", "order": "asc" }] } }

    let response = this.employeeService.getEmployeeCategoryList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.categoryList = response.data.employees;

      }

    });

  }

  // Custom validator function
  noFutureDateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null;
      const inputDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Ignore time
      if (inputDate > today) {
        return { futureDate: true };
      }
      return null;
    };
  }

  // Non-negative validator
  nonNegativeValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value == null || control.value === '') return null;
      return Number(control.value) < 0 ? { negative: true } : null;
    };
  }

  getSortedShopEmployeeMapping(data: any[]): any[] {
    return [...data].sort((a, b) => {
      if (a.code < b.code) return 1;
      if (a.code > b.code) return -1;
      return b.name.localeCompare(a.name);
    });
  }

  trackByShop(index: number, shop: any) {
    return shop.id || shop.code;
  }

  isShopChecked(shop: any): boolean {
    return String(shop.is_exists) === '1';
  }

  getShopByCode(code: string): any {
    return this.shopEmployeeMapping.find((s: { code: string; }) => s.code == code);
  }

  onPrimaryShopChange(shop: any, isPrimary: boolean) {
    if (isPrimary) {
      // Clear all other primary shops
      this.shopEmployeeMapping.forEach((s: any) => s.is_primary = false);

      const targetShop = this.getShopByCode(shop.code);
      if (targetShop) {
        targetShop.is_primary = true;
        // Auto-assign the shop if it's primary but not active
        if (targetShop.is_exists !== '1' && targetShop.is_exists !== true) {
          this.onShopCheckboxChange(targetShop, true);
        }
      }
    }
  }

  onShopCheckboxChange(shop: any, checked: boolean) {
    const idx = this.shopEmployeeMapping.findIndex(s => (s.id || s.code) === (shop.id || shop.code));
    if (idx > -1) {
      this.shopEmployeeMapping = [
        ...this.shopEmployeeMapping.slice(0, idx),
        { ...shop, is_exists: checked ? '1' : '0' },
        ...this.shopEmployeeMapping.slice(idx + 1)
      ];
      this.sortedShopEmployeeMapping = this.getFilteredAndSortedShopEmployeeMapping();
      this.cdr.detectChanges();
    }
  }

  getFilteredAndSortedShopEmployeeMapping(): any[] {
    let filtered = this.shopEmployeeMapping;
    if (this.selectedAreas && this.selectedAreas.length > 0) {
      filtered = filtered.filter(shop => this.selectedAreas.includes(shop.city));
    }
    if (this.shopSearch && this.shopSearch.trim() !== '') {
      const search = this.shopSearch.trim().toLowerCase();
      filtered = filtered.filter(shop =>
        (shop.code && shop.code.toLowerCase().includes(search)) ||
        (shop.name && shop.name.toLowerCase().includes(search)) ||
        (shop.city && shop.city.toLowerCase().includes(search))
      );
    }
    return this.getSortedShopEmployeeMapping(filtered);
  }

  onShopSearchChange(search: string) {
    this.shopSearch = search;
    this.sortedShopEmployeeMapping = this.getFilteredAndSortedShopEmployeeMapping();
    this.cdr.detectChanges();
  }

  isAllShopsChecked(): boolean {
    return this.sortedShopEmployeeMapping.length > 0 &&
      this.sortedShopEmployeeMapping.every(shop => this.isShopChecked(shop));
  }

  isSomeShopsChecked(): boolean {
    return this.sortedShopEmployeeMapping.some(shop => this.isShopChecked(shop)) &&
      !this.isAllShopsChecked();
  }

  onSelectAllShops(checked: boolean) {
    const updated = this.shopEmployeeMapping.map(shop => {
      if (this.sortedShopEmployeeMapping.some(s => (s.id || s.code) === (shop.id || shop.code))) {
        return { ...shop, is_exists: checked ? '1' : '0' };
      }
      return shop;
    });
    this.shopEmployeeMapping = updated;
    this.sortedShopEmployeeMapping = this.getFilteredAndSortedShopEmployeeMapping();
    this.cdr.detectChanges();
  }

  onAreaSelectionChange(selected: string[]) {
    this.selectedAreas = selected;
    this.sortedShopEmployeeMapping = this.getFilteredAndSortedShopEmployeeMapping();
    this.cdr.detectChanges();
  }

  showNotes(shop: any): void {
    if (!shop.notes) return;
    const dialogData = new ConfirmDialogModel('Shop Notes', shop.notes);
    dialogData.showNoButton = false;
    dialogData.yesButtonCaption = 'OK';

    this.dialog.open(ConfirmDialogComponent, {
      minWidth: '400px',
      maxWidth: '600px',
      data: dialogData,
      disableClose: false
    });
  }
}

